import { render, staticRenderFns } from "./MainNavItem.vue?vue&type=template&id=dcde0168&"
import script from "./MainNavItem.vue?vue&type=script&lang=js&"
export * from "./MainNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports